export default "__VITE_ASSET__VI4Fbpud__"